import { render, staticRenderFns } from "./FooterV1.vue?vue&type=template&id=65419c5b&"
import script from "./FooterV1.vue?vue&type=script&lang=js&"
export * from "./FooterV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports